import React from "react";
import { useTranslation } from "react-i18next";
import { Card, CardBody } from "reactstrap";
import { ClientDetailDto } from "src/store/clients/type";

const ClientDetailCard = ({ client }: { client: ClientDetailDto }) => {
  const { t } = useTranslation();
  const rows = [
    { i: "mdi-account-tie-outline", text: t("Clients.AuthorizedPersonFullName"), value: `${client.AuthorizedPersonName ?? ""} ${client.AuthorizedPersonSurname ?? ""}`.trim() },
    { i: "mdi-email-outline", text: t("Clients.CorporateEmail"), value: client.CorporateEmail },
    { i: "mdi-phone-outline", text: t("Clients.CorporatePhone"), value: client.CorporatePhone },
    { i: "mdi-office-building-outline", text: t("Clients.TaxOffice"), value: client.CorporateRegisteredTaxOffice },
    { i: "mdi-pound", text: t("Clients.TaxNumber"), value: client.CorporateRegisteredTaxNumber },
    { i: "mdi-clock-outline", text: t("Clients.SystemTimeZone"), value: client.SystemTimeZoneName },
    { i: "mdi-cash", text: t("Clients.Currency"), value: client.Currency },
  ];
  return (
    <Card>
      <CardBody>
        <div className="client-info">
          {rows.map((r, i) => (
            <div className="client-info__item" key={i}>
              <span className="client-info__ic">
                <i className={"mdi " + r.i} />
              </span>
              <div className="client-info__text">
                <div className="client-info__label">{r.text}</div>
                <div className="client-info__value">{r.value || "—"}</div>
              </div>
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  );
};
export default ClientDetailCard;
